import React from 'react';
import Spinner from 'react-spinner-material';
import DelayRender from './DelayRender';
import { withT } from '../context/t';

const DocumentDownload = ({
  onClick,
  fileName,
  title,
  linkText,
  format,
  size,
  ready,
  t,
}) => (
  <div class="document-block print-hide">
    <DelayRender
      ready={ready}
      loadingEl={
        <Spinner size={100} spinnerColor="#eee" spinnerWidth={10} visible />
      }
    >
      <a
        onClick={onClick}
        href={fileName}
        title={t('interface:downloadTooltip', { title })}
        class="document-block__link"
      >
        <div>
          <h2 class="document-block__heading">{linkText}</h2>
          <p class="document-block__size">
            {format.toUpperCase()} {size}
          </p>
        </div>

        <svg
          class="document-block__icon"
          width="27"
          height="36"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M15.75 9.563V0H1.687C.752 0 0 .752 0 1.688v32.624C0 35.248.752 36 1.688 36h23.625c.935 0 1.687-.752 1.687-1.688V11.25h-9.563c-.928 0-1.687-.76-1.687-1.688zm5.375 14.86l-6.78 6.73a1.199 1.199 0 01-1.69 0l-6.779-6.73c-.714-.707-.213-1.923.791-1.923h4.583v-5.625c0-.622.503-1.125 1.125-1.125h2.25c.622 0 1.125.503 1.125 1.125V22.5h4.583c1.004 0 1.505 1.216.792 1.924zm5.383-17.04L19.624.493A1.686 1.686 0 0018.43 0H18v9h9v-.429c0-.443-.176-.872-.492-1.188z"
            fill-rule="nonzero"
          />
        </svg>
      </a>
    </DelayRender>
  </div>
);

export default withT()(DocumentDownload);
